// extracted by mini-css-extract-plugin
export default {"hamburguer":"HamburguerIcon_hamburguer__1uV9O"};